class ProductCardSwatchSlider {
  constructor(element) {
    this.element = element;
    this.viewport = element.querySelector("[data-swatch-viewport]");
    this.arrow = element.querySelector("[data-swatch-next]");
    this.progress = element.querySelector("[data-swatch-progress]");
    this.bar = element.querySelector("[data-swatch-progress-bar]");

    if (!this.viewport || !this.arrow) {
      console.warn("[Swatches] Missing viewport or arrow", element);
      return;
    }

    // Always keep the arrow clickable
    this.arrow.disabled = false;

    this.arrow.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      console.log("[Swatches] Arrow clicked");

      this.scrollNext();
    });

    this.viewport.addEventListener(
      "scroll",
      () => this.update(),
      { passive: true }
    );

    if ("ResizeObserver" in window) {
      this.resizeObserver = new ResizeObserver(() => {
        this.update();
      });

      this.resizeObserver.observe(this.viewport);

      const track = this.viewport.querySelector(
        ".product-card-swatches__track"
      );

      if (track) this.resizeObserver.observe(track);
    }

    this.update();

    console.log("[Swatches] Slider initialized", element);
  }

  scrollNext() {
    const viewport = this.viewport;

    const maxScroll = Math.max(
      0,
      viewport.scrollWidth - viewport.clientWidth
    );

    const currentScroll = viewport.scrollLeft;

    console.log("[Swatches] Scroll info:", {
      currentScroll,
      maxScroll,
      scrollWidth: viewport.scrollWidth,
      clientWidth: viewport.clientWidth
    });

    if (maxScroll <= 0) {
      console.warn("[Swatches] No horizontal overflow detected");
      return;
    }

    const atEnd = currentScroll >= maxScroll - 2;

    const targetScroll = atEnd
      ? 0
      : Math.min(
          currentScroll + Math.max(60, viewport.clientWidth * 0.7),
          maxScroll
        );

    viewport.scrollTo({
      left: targetScroll,
      behavior: window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches ? "auto" : "smooth"
    });

    console.log("[Swatches] Target scroll:", targetScroll);
  }

  
  update() {
    const viewport = this.viewport;

    const maxScroll = Math.max(
      0,
      viewport.scrollWidth - viewport.clientWidth
    );

    const hasOverflow = maxScroll > 2;
    const atEnd = viewport.scrollLeft >= maxScroll - 2;

    this.arrow.hidden = !hasOverflow;
    this.arrow.disabled = !hasOverflow;

    if (this.progress) {
      this.progress.hidden = !hasOverflow;
    }

    if (!this.bar) return;

    if (!hasOverflow) {
      this.bar.style.width = "100%";
      this.bar.style.left = "0%";
      this.arrow.style.transform = "rotate(0deg)";
      return;
    }

    const visibleRatio =
      viewport.clientWidth / viewport.scrollWidth;

    const thumbWidth = visibleRatio * 100;

    const scrollProgress = Math.min(
      1,
      Math.max(0, viewport.scrollLeft / maxScroll)
    );

    this.bar.style.width = `${thumbWidth}%`;
    this.bar.style.left =
      `${scrollProgress * (100 - thumbWidth)}%`;

    this.arrow.setAttribute(
      "aria-label",
      atEnd ? "Back to first colors" : "View more colors"
    );

    this.arrow.style.transform =
      atEnd ? "rotate(180deg)" : "rotate(0deg)";
  }
}

const swatchSliders = new WeakMap();

function initProductCardSwatches(root = document) {
  const sliders = [];

  if (root.matches?.("[data-swatch-slider]")) {
    sliders.push(root);
  }

  sliders.push(
    ...root.querySelectorAll("[data-swatch-slider]")
  );

  sliders.forEach((element) => {
    if (swatchSliders.has(element)) return;

    const slider = new ProductCardSwatchSlider(element);

    if (slider.viewport && slider.arrow) {
      swatchSliders.set(element, slider);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    () => initProductCardSwatches()
  );
} else {
  initProductCardSwatches();
}

document.addEventListener("shopify:section:load", (event) => {
  initProductCardSwatches(event.target);
});

// Initialize dynamically added product cards
const swatchObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        initProductCardSwatches(node);
      }
    });
  }
});

swatchObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});